import { action, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { CourseIndexView } from '../../../types/courses';
import { CourseApis } from '../../../apis/courses';
import { CourseStatIndexView } from '../../../types/courseStats';
import { CourseStatApi } from '../../../apis/courseStats';
import { ExamSectionStatApi } from '../../../apis/examSectionStats';
import { ExamSectionStatIndexView } from '../../../types/exam_section_stats';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

export type CourseListType = 'all' | 'design' | 'marketing';

export class CourseListPageState {
  preview = false;
  courseListType: CourseListType = 'all';
  courses: RemoteResourceV3<CourseIndexView[]> = RemoteResourceV3.loading();
  completeLessons: RemoteResourceV3<CourseStatIndexView[]> = RemoteResourceV3.loading();
  examSectionStats: RemoteResourceV3<ExamSectionStatIndexView[]> = RemoteResourceV3.loading();
  showCourseSetList = false;

  constructor() {
    makeObservable(this, {
      preview: observable,
      courseListType: observable,
      courses: observable,
      completeLessons: observable,
      examSectionStats: observable,
      showCourseSetList: observable,
      init: action.bound,
      reloadCourses: action.bound,
      setListType: action.bound,
      reloadCompleteLesson: action.bound,
      reloadCourseExamStat: action.bound,
    });
  }

  async init(preview: boolean) {
    const { currentUser } = GlobalStatesV3;
    this.preview = preview;
    this.reloadCourses();
    this.reloadCompleteLesson();
    this.reloadCourseExamStat();
    if (currentUser.currentUser.days_since_join < 30) {
      this.showCourseSetList = false;
    }
  }

  async reloadCourses() {
    await updateRemoteResourceV3(
      this.courses,
      (v) => (this.courses = v),
      () => CourseApis.index(this.preview)
    );
  }

  setListType(type: CourseListType) {
    this.courseListType = type;
  }

  async reloadCompleteLesson() {
    await updateRemoteResourceV3(
      this.completeLessons,
      (v) => (this.completeLessons = v),
      () => CourseStatApi.index()
    );
  }

  async reloadCourseExamStat() {
    await updateRemoteResourceV3(
      this.examSectionStats,
      (v) => (this.examSectionStats = v),
      () => ExamSectionStatApi.index()
    );
  }

  toggleShowCourseSetList(): void {
    this.showCourseSetList = !this.showCourseSetList;
  }
}
